import { render, staticRenderFns } from "./HtmlField.vue?vue&type=template&id=01bf0163"
import script from "./HtmlField.vue?vue&type=script&lang=js"
export * from "./HtmlField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports